module.exports = {
  siteUrl: 'https://bamboobroom.com',
  siteTitle: 'bbb',
  siteDescription: 'blog',
}
